import { StatusBadge } from "../components/StatusBadge";
import { orderedStatuses, statusDefinitions } from "../lib/status";
import { leafItems } from "../lib/progress";
import type { ProjectRole, WorkItem, WorkStatus } from "../types/domain";

export function BoardView({
  items,
  role,
  onStatusChange,
}: {
  items: WorkItem[];
  role: ProjectRole | null;
  onStatusChange(itemId: string, status: WorkStatus, reason: string | null): Promise<void>;
}) {
  const canEdit = role === "owner" || role === "editor";
  const leaves = leafItems(items);
  return (
    <div className="view-stack">
      <section className="section-toolbar">
        <div>
          <span className="eyebrow">Flujo de trabajo</span>
          <h2>Board de estados</h2>
          <p>Una vista operativa; la jerarquía permanece en Roadmap.</p>
        </div>
      </section>
      <section className="board-scroll">
        <div className="board-grid">
          {orderedStatuses.map((status) => {
            const bucket = leaves.filter((item) => item.status === status);
            return (
              <div className="board-column" key={status}>
                <header>
                  <StatusBadge status={status} />
                  <span>{bucket.length}</span>
                </header>
                <div className="board-column__items">
                  {bucket.map((item) => (
                    <article className="board-card" key={item.id}>
                      <span className="item-type-label">{item.itemType}</span>
                      <h3>{item.title}</h3>
                      {item.description && <p>{item.description}</p>}
                      <footer>
                        <span className="weight-chip">Peso {item.weight}</span>
                        {canEdit && (
                          <select
                            aria-label={`Mover ${item.title}`}
                            value={item.status}
                            onChange={(event) =>
                              void onStatusChange(
                                item.id,
                                event.target.value as WorkStatus,
                                "Transición desde el board",
                              )
                            }
                          >
                            {orderedStatuses.map((target) => (
                              <option key={target} value={target}>
                                {statusDefinitions[target].label}
                              </option>
                            ))}
                          </select>
                        )}
                      </footer>
                    </article>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
